import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { NonDismissibleDialog } from '@scoir/modals'
import { isEqual, cloneDeep } from 'lodash'

import { actions as userActions } from 'store/user'
import EditProfileForm from 'components/EditProfileForm'
import { validateLink } from 'components/LinkField'

import MeetingLinkInput from './MeetingLinkInput'

import './RegisterModal.scss'

const getDefaultState = ({ user, placeName }) => ({
  isValid: true,
  errorSavingUser: false,
  updatedUserFields: false,
  editUser: cloneDeep(user),
  placeName,
  isValidPlaceName: true,
  isConfirming: false,
})

export class RegisterModal extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    show: PropTypes.bool,
    title: PropTypes.string,
    user: PropTypes.object.isRequired,
    updateUser: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    allowRepMeeting: PropTypes.bool,
    placeName: PropTypes.string,
  }
  state = getDefaultState(this.props)
  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.user, this.props.user)) {
      this.setState({
        editUser: cloneDeep(this.props.user),
      })
    }
  }
  cancel() {
    this.props.onClose()
    this.setState(getDefaultState(this.props))
  }
  confirm() {
    this.setState({ isConfirming: true })

    if (this.state.updatedUserFields) {
      return this.props
        .updateUser(this.state.editUser)
        .then(() => {
          this.setState({
            errorSavingUser: false,
          })
          this.props.onConfirm(this.state.placeName)
        })
        .catch(() =>
          this.setState({
            errorSavingUser: true,
          }),
        )
        .finally(() => {
          this.setState({ isConfirming: false })
        })
    }

    this.props.onConfirm(this.state.placeName).finally(() => {
      this.setState({ isConfirming: false })
    })
  }
  update(editUser, isValid) {
    this.setState({
      editUser,
      isValid,
      updatedUserFields: true,
    })
  }
  cancelEditing() {
    this.setState({
      editUser: cloneDeep(this.props.user),
    })
  }
  updateMeetingPlaceName = (placeName = '') =>
    this.setState({
      isValidPlaceName: validateLink(placeName),
      placeName,
    })
  render() {
    const { children, show, title, allowRepMeeting } = this.props
    const { placeName } = this.state
    return (
      <NonDismissibleDialog
        open={show}
        headerText={title}
        className="register-modal-comp"
        onClose={() => this.cancel()}
      >
        <NonDismissibleDialog.Body>
          {children}
          <b className="section-title section-border">Review & update your profile info</b>
          <div className="profile-update-section">
            <EditProfileForm
              className="edit-profile-card"
              editUser={this.state.editUser}
              onCancel={() => this.cancelEditing()}
              onUpdate={(editUser, isValid, field, value) => this.update(editUser, isValid, field, value)}
            />
            {allowRepMeeting && (
              <Fragment>
                <b className="section-title">Review or add virtual meeting link</b>
                <div className="meeting-link-container">
                  <MeetingLinkInput
                    meetingLink={placeName}
                    onChange={this.updateMeetingPlaceName}
                  />
                </div>
              </Fragment>
            )}
          </div>
          {this.state.errorSavingUser && (
            <div className="error">An error occured while attempting to save changes to your profile.</div>
          )}
        </NonDismissibleDialog.Body>
        <NonDismissibleDialog.Footer>
          <NonDismissibleDialog.Footer.CloseButton>Cancel</NonDismissibleDialog.Footer.CloseButton>
          <NonDismissibleDialog.Footer.PrimaryActionButton
            disabled={!this.state.isValid || !this.state.isValidPlaceName || this.state.isConfirming}
            onClick={() => this.confirm()}
          >
            Confirm
          </NonDismissibleDialog.Footer.PrimaryActionButton>
        </NonDismissibleDialog.Footer>
      </NonDismissibleDialog>
    )
  }
}
export default connect(
  (store) => ({
    user: store.user.record,
  }),
  {
    updateUser: userActions.updateUser,
  },
)(RegisterModal)
